import { IColumnsItem } from '@/components/custom-table/type.d';
import { IGetDomainListRes } from '@/api/system-config/type.d';
import { IFilters } from '@/core/plugins/filter';

export const renderColumns = (
  handleEditItem: (row: IGetDomainListRes) => void,
  handleDelItem: (code: string) => void,
  filters: IFilters,
  canUpdate: boolean,
  canDelete: boolean,
): IColumnsItem<IGetDomainListRes>[] => [
  {
    label: '域名所属系统',
    prop: 'domainSystem',
  },
  {
    label: '域名地址',
    prop: 'domainBaseUrl',
    minWidth: '80',
  },
  {
    label: '域名名称描述',
    prop: 'domainDesc',
    ellipsis: true,
  },
  {
    label: '环境',
    prop: 'domainEnv',
  },
  {
    label: '创建时间',
    render: row => <div>{filters.formatTime(row.createdTime)}</div>,
  },
  {
    label: '更新时间',
    render: row => <div>{filters.formatTime(row.revisedTime)}</div>,
  },
  {
    label: '操作',
    width: '180',
    align: 'center',
    fixed: 'right',
    render: row => (
      <div class="flex flex-wrap btns">
        {canUpdate && <el-button
          size="default"
          type="primary"
          onClick={() => handleEditItem(row)}
        >
          编辑
        </el-button>}
        {canDelete && <el-button size="default" type="danger" onClick={() => handleDelItem(row.id)}>
          删除
        </el-button>}
      </div>
    ),
  },
];
